import React from 'react';
import ReactClient from 'react-dom/client';
import App from './App';

// Create react Root with createRoot
const root = ReactClient.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
